import { Component, Input, EventEmitter, Output, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { momentCustom } from '@projects/shared/src/app/utils/helper';
import moment from 'moment';

@Component({
  selector: 'advance-daterangepicker',
  templateUrl: './advance-daterangepicker.component.html',
  styleUrls: ['./advance-daterangepicker.component.scss'],
})
export class AdvanceDateRangePickerComponent implements OnInit {
  @Input() value: Array<moment.Moment> | moment.Moment = [moment(), moment()];
  @Input() showRanges = true;
  @Input() isSinglePicker = false;
  @Input() isTimePicker = false;
  @Input() timePicker24Hour = false;
  @Input() isMinPicker = false;
  @Input() minDate = moment().subtract(1, 'years');
  @Output() apply = new EventEmitter();

  dateLabel!: string;
  selectedDate = {
    startDate: moment(),
    endDate: moment(),
  };
  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'This Week': [moment().startOf('week'), moment()],
    'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
    'This Month': [moment().startOf('month'), moment()],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Current Quarter': [moment().startOf('quarter'), moment()],
    'Last Quarter': [
      moment().subtract(1, 'quarter').startOf('quarter'),
      moment().subtract(1, 'quarter').endOf('quarter'),
    ],
  };
  locale = {
    format: 'MMMM D, YYYY',
    displayFormat: 'MMMM D, YYYY',
    direction: 'ltr',
    weekLabel: 'W',
    separator: ' - ',
    cancelLabel: 'Cancel',
    applyLabel: 'Apply',
    customRangeLabel: 'Custom range',
    daysOfWeek: momentCustom().weekdaysMin(),
    monthNames: momentCustom().monthsShort(),
    firstDay: momentCustom().localeData().firstDayOfWeek(),
  };

  ngOnInit(): void {
    this.updateDates();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.updateDates();
    }
  }

  updateDates() {
    if (this.value && Array.isArray(this.value)) {
      this.selectedDate = {
        startDate: this.value[0],
        endDate: this.value[1],
      };
    } else {
      //* re-initlaizing whole object to detect change
      this.selectedDate = {
        startDate: moment(this.value),
        endDate: moment(this.value),
      };
      // this.selectedDate.startDate = moment(this.value);
      // this.selectedDate.endDate = moment(this.value);
    }
    this.updateLabel();
  }

  dateUpdated({ startDate, endDate, mins }: any) {
    if (!startDate) return;

    if (!this.isSinglePicker && Array.isArray(this.value)) {
      this.value[0] = startDate;
      this.value[1] = endDate;
    } else {
      this.value = startDate;
    }

    this.updateLabel();
    this.apply.emit({ values: this.value, mins });
  }

  updateLabel() {
    this.dateLabel = moment(this.selectedDate.startDate).format('DD-MMM-YY');
    if (!this.isSinglePicker) {
      this.dateLabel += ' to ' + moment(this.selectedDate.endDate).format('DD-MMM-YY');
    }
    if (this.isSinglePicker && this.isTimePicker) {
      this.dateLabel = moment(this.selectedDate.startDate).format('DD-MMM-YY h:mm:ss A');
    }
  }
}
